import React from 'react';

export function SolutionSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-8">
            Get a detailed audit report in 2 minutes
          </h2>
          
          <div className="max-w-4xl mx-auto">
            <p className="text-xl sm:text-2xl text-gray-700 leading-relaxed">
              Connect your GitHub repository and our AI analyzes your codebase to generate a comprehensive report showing exactly what's missing for growth — analytics tracking, customer support setup, email capture, marketing pixels, conversion tracking — with step-by-step implementation guides.
            </p>
          </div>
        </div>
        
        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <svg className="w-8 h-8 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">GitHub Integration & Analysis</h3>
              <p className="text-gray-600 leading-relaxed">
                Connect your GitHub repo with one click. AI scans your entire codebase to identify missing growth features, implementation gaps, and optimization opportunities specific to your tech stack.
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-red-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Growth Blocker Detection</h3>
              <p className="text-gray-600 leading-relaxed">
                Automatically identifies critical missing pieces: analytics tracking, customer support setup, email capture, marketing pixels, and conversion tracking opportunities.
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Actionable Implementation Plan</h3>
              <p className="text-gray-600 leading-relaxed">
                Get prioritized recommendations with detailed step-by-step instructions, code examples, and implementation guides tailored to your specific codebase.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
} 